/**
 * Standardized date formatter that works with Firebase Timestamps and regular Date objects
 * Used across both vendor and client applications to ensure consistency
 */
export const formatDate = (dateValue) => {
    if (!dateValue)
        return 'N/A';
    try {
        // Check if it's a Firebase Timestamp (has toDate method)
        if (dateValue && typeof dateValue.toDate === 'function') {
            return dateValue.toDate().toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        }
        // Handle regular Date objects or strings
        const date = new Date(dateValue);
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return 'N/A';
        }
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    }
    catch (e) {
        console.error('Error formatting date:', e);
        return 'N/A';
    }
};
